<template>
  <section>
    <compWrapper v-if="handleAuth('fbb.warehouse.basic')" :title="
    $t('global.common.base_information', {
      defaultValue: '基本信息',
    })
      " theme="primary">
      <vForm class="padding-top-15 padding-left-15 padding-right-15" :style="`margin-bottom: -10px;`" :labelWidth="150"
        :model="warehouseBaseInfo" ref="myForm">
        <vRow>
          <vCol span="12">
            <vFormItem :style="
            type != 'add' ? 'margin-bottom: 5px;' : 'position: relative;'
              " :label="
  $t('fbb.inbound.warehouse_type', {
    defaultValue: '仓库类型',
  })
    " prop="warehouseType" :rules="type != 'add' ? '' : required">
              <div v-if="type == 'add'">
                <vSelect @on-change="handleWarehouseType" v-model="warehouseBaseInfo.warehouseType">
                  <vOption v-for="item in getWarehouseTypes" :key="item.value" :value="item.value">{{ item.label }}
                  </vOption>
                </vSelect>
                <div class="color-error" style="position: absolute; left: 120px; top: 25px">
                  {{ selectText }}
                </div>
              </div>
              <div class="font-bold" v-else>
                {{ warehouseTypeLabel }}
              </div>
            </vFormItem>
          </vCol>
          <vCol span="12">
            <vFormItem :style="type == 'query' ? 'margin-bottom: 5px;' : ''" :label="
            $t('fbb.warehouse.warehouse_name', {
              defaultValue: '仓库名称',
            })
              " prop="warehouseName" :rules="type === 'query' ? '' : required">
              <vInput v-if="type !== 'query'" v-model="warehouseBaseInfo.warehouseName" />
              <div v-else class="font-bold">
                {{ warehouseBaseInfo.warehouseName }}
              </div>
            </vFormItem>
          </vCol>
          <compFormEdit v-if="type !== 'query'" class="margin-layout margin-top-0" ref="formbase" :labelWidth="150"
            :formdata="getBase" v-model="warehouseBaseInfo">
          </compFormEdit>
          <compFormQuery v-else class="margin-layout margin-top-0" :labelWidth="150" :formdata="getBase"
            :value="warehouseBaseInfo"></compFormQuery>
        </vRow>
      </vForm>
    </compWrapper>
    <compWrapper v-if="handleAuth('fbb.warehouse.basic')" :title="
    $t('global.common.address_information', {
      defaultValue: '地址信息',
    })
      " theme="info">
      <compFormEdit v-if="type !== 'query'" class="margin-layout" ref="formaddress" :formdata="getAddress"
        v-model="warehouseAddress"></compFormEdit>
      <compFormQuery v-else class="margin-layout" :formdata="getAddress" :value="warehouseAddress"></compFormQuery>
      <vButtonGroup slot="footer" v-if="type !== 'query'">
        <vButton theme="primary" @click="save">{{
          $t("global.common.update_OK", { defaultValue: "确定" })
        }}</vButton>
        <vButton class="margin-left-10" @click="cancel">{{
          $t("global.common.operation_cancel", {
            defaultValue: "取消",
          })
        }}</vButton>
      </vButtonGroup>
    </compWrapper>
    <compWrapper :title="$t('fbb.warehouse.customer_list', { defaultValue: '客户列表' })" theme="info" v-if="
    (warehouseBaseInfo.warehouseType != 4 || type === 'query') &&
      // handleAuth('fbb.warehouse.organizationset') && handleAuth('fbb.warehouse.client')
      handleAuth('fbb.warehouse.client')
      ">
      <compCustomer class="margin-layout" ref="warehouseOrgIds" :data="warehouseOrgChannels"
        :status="warehouseBaseInfo.active" :querytype="type" :activeids="id"></compCustomer>
    </compWrapper>
    <compWrapper v-if="warehouseBaseInfo.warehouseType == 4" :title="
    this.$t('fbb.warehouse.onsite_channel_list', {
      defaultValue: 'ONSITE仓渠道列表',
    })
      " theme="info">
      <compAccount class="margin-layout" ref="channelIds" :data="warehouseOrgChannels"></compAccount>
    </compWrapper>
    <compWrapper v-if="handleAuth('fbb.warehouse.basic')" :title="
    $t('global.common.other_information', {
      defaultValue: '其他信息',
    })
      " theme="info">
      <compFormEdit v-if="type !== 'query'" class="margin-layout" :formdata="getOtherInfo" v-model="formData">
      </compFormEdit>
      <compFormQuery v-else class="margin-layout" :formdata="getOtherInfo" :value="formData"></compFormQuery>
      <!-- <vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup> -->
      <!-- <div
        class="text-right margin-top-20 padding-right-20"
        v-show="type != 'query'"
      >
        <vButton theme="primary" @click="save">{{
          $t("global.common.update_OK", { defaultValue: "确定" })
        }}</vButton>
        <vButton class="margin-left-10" @click="cancel">{{
          $t("global.common.operation_cancel", {
            defaultValue: "取消",
          })
        }}</vButton>
      </div> -->
    </compWrapper>
    <compWrapper :title="
    $t('global.common.operate_history', {
      defaultValue: '操作历史',
    })
      " theme="gray" v-if="type === 'query'">
      <compLog class="margin-layout" :data="logList" :columns="getLogcolumns"></compLog>
    </compWrapper>
    <vLoading size="large" transfer :loading="loading"></vLoading>
    <!--     <compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show = false" @on-confirm="getDetail">
      <component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" v-on="modalProps.on" />
    </compModal> -->
    <vModal class="hidefooter customerupload" v-model="uploadAttachmentModal" title="附件上传">
      <compUpload v-bind="getFileProps" @on-success="uploadAttachmentSuccess" @on-close="uploadAttachmentClose">
      </compUpload>
      <footer slot="footer" v-show="false"></footer>
    </vModal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { HttpSaveManageWare, HttpManageWare, HttpWarehouseListDeleteAttaches } from "@/service/basicdata";
import { HttpAreaList } from "@mods/service/dictionary";
import mixin from "./mixin";
import compCustomer from "./customer";
import compAccount from "./account";
import { type } from "os";
export default {
  props: ['activeids', 'querytype'],
  mixins: [mixin],
  components: {
    compLog: () => import("@components/templates/log"),
    compModal: () => import("@components/templates/modal"),
    compUpload: () => import("@components/templates/upload"),
    compCustomer,
    compAccount,
  },
  data() {
    return {
      loading: false,
      type: this.$route.params.type || this.querytype,
      id: this.$route.query.id || this.activeids,
      formData: {
        businessType: [],
        isLabelBefore: '1',
        isAttachHandling: '1',
      },
      warehouseTypeLabel: "",
      warehouseBaseInfo: {
        hoseOrgId: this.$store.state.organization.id,
        hoseOrgName: this.$store.state.organization.name,
        attributes: [],
        active: this.$route.params.type == 'add' ? "NO" : '',
        returnLastDay: 0
      },
      warehouseAddress: {
        country: "US",
      },
      warehouseOrgChannels: [],
      // warehouseOrgIds: [],
      // channelIds: [],
      logList: [], //log,
      /*       modalProps: {
              show: false,
            }, */
      selectText: "",
      isTransfer: false,
      areaList: [],
      showAttach: false,
      uploadAttachmentModal: false,
      attachesList: [],//附件数据,
      flag: true,
      zoneClosingTime: ''//local时间
    };
  },
  created() {
    this.getDetail();
    this.getArea();
  },
  computed: {
    getFileProps() {
      return {
        action: process.env.VUE_APP_APIURL_FBB + "/api/v2/warehouse/uploadAttach",
        contextId: global.SYSID,
        name: "multipartFile",
        data: this.type === 'edit' ? { id: this.id } : {}
      }
    },
    ...mapGetters("common", ["getCurrencyList", "getStateList"]),
    ...mapGetters("dictionary", [
      "getBillcusorgList",
      "getBillcusWareList",
      "getAreaList",
      "getTimeZone",
      "getCountryList"
    ]),
    required() {
      return [
        {
          required: true,
          message: this.$t("global.common.required", {
            defaultValue: "该信息不能为空,请填写",
          }),
        },
      ];
    },
    /**
     * 根据状态显示不同按钮
     */
    getStatusBtns() {
      const btn = [
        {
          name: this.$t("global.common.save", {
            defaultValue: "保存",
          }),
          theme: "primary",
          show: this.type !== "query",
          run: this.save,
        },
        {
          name: this.$t("global.common.return", {
            defaultValue: "返回",
          }),
          theme: "default",
          show: true,
          run: this.cancel,
        },
      ];
      return btn.filter((item) => item.show);
    },

    getBase() {
      let baseArr = [
        {
          label: this.$t("fbb.warehouse.warehouse_code", {
            defaultValue: "仓库代码",
          }),
          key: "wahouseCode",
          query: this.type != "add",
        },
        {
          label: this.$t("fbb.warehouse.property", {
            defaultValue: "附加属性",
          }),
          key: "attributes",
          tag: "vCheckBox",
          props: {
            strict: false,
          },
          options: this.getWarehouseAttrs.map((item) => {
            return {
              label: item.label,
              trueValue: item.value,
            };
          }),
          required: false,
          render: () => {
            return this.getWarehouseAttrs.map((json) => {
              const bool =
                this.warehouseBaseInfo.attributes.indexOf(json.value) > -1;
              return (
                <vCheckbox value={bool} disabled>
                  {json.label}
                </vCheckbox>
              );
            });
          },
        },
        // {
        // 	label: this.$t('fbb.warehouse.owner_org', { defaultValue: "所属管理方" }),
        // 	key: "hoseOrgName",
        // 	query: true
        // },
        {
          label: this.$t("global.common.currency", {
            defaultValue: "币种",
          }),
          key: "currency",
          tag: "vSelect",
          options: this.getCurrencyList,
        },
        {
          label: this.$t("fbb.warehouse.status", {
            defaultValue: "活动状态",
          }),
          key: "active",
          tag: "vSwitch",
          props: {
            trueValue: "YES",
            falseValue: "NO",
          },
        },
        {
          label: this.$t("fbb.warehouse.closing_time", {
            defaultValue: "截单时间（UTC/Local）",
          }),
          key: "closingTime",
          tag: "vDatepicker",
          props: {
            format: "HH:MM:SS",
            // confirm:false,
          },
          required: false,
          render: () => {
            if (this.warehouseBaseInfo.closingTime && this.zoneClosingTime) {
              return this.warehouseBaseInfo.closingTime + '/' + this.zoneClosingTime;
            } else if (this.warehouseBaseInfo.closingTime) {
              return this.warehouseBaseInfo.closingTime
            } else {
              return '--'
            }
          },
        },
        /* {
        label: "是否需要新品审核",
        key: "aduit",
        tag: 'vSwitch',
        props: {
          trueValue: 'YES',
          falseValue: 'NO',
        }
        }, */
        {
          label: this.$t("fbb.warehouse.receiving_time", {
            defaultValue: "收货时间",
          }),
          key: "reserveTime",
          tag: "vDatepicker",
          style: 'width:100%',
          props: {
            format: 'HH:MM:SS ~ HH:MM:SS',
            confirm: false,
          },
          render: () => {
            return this.warehouseBaseInfo.reserveTime || "--";
          },
        },
        {
          label: this.$t("fbb.warehouse.dock", {
            defaultValue: "签到DOCK",
          }),
          key: "dockNum",
          tag: "vInput",
          props: {
            placeholder: "请输入1-5、8、11-15",
          }
        },
        {
          label: this.$t("fbb.warehouse.capacity_cbm", {
            defaultValue: "分配库容(CBM)",
          }),
          key: "capacity",
          required: false,
          tag: "vInput",
        },
        {
          label: this.$t("fbb.manageware.operatetype", {
            defaultValue: "运营方式",
          }),
          key: "operateType",
          tag: "vSelect",
          required: false,
          options: [
            { value: 1, label: this.$t("fbb.inbound.self_operated_warehouse", { defaultValue: "自营仓", }) },
            { value: 2, label: this.$t("fbb.inbound.third_party_warehouse", { defaultValue: "三方仓", }) },
          ]
        },
        {
          label: this.$t("fbb.manageware.opentime", {
            defaultValue: "开仓时间",
          }),
          key: "openDate",
          tag: "vDatepicker",
          required: false,
          props: {
            format: "yyyy-mm-dd",
          },
          render: () => {
            return this.warehouseBaseInfo.openDate || "--";
          },
        },
        {
          label: this.$t("fbb.manageware.daicestarttime", {
            defaultValue: "合同开始时间",
          }),
          key: "contractStartDate",
          tag: "vDatepicker",
          required: false,
          props: {
            format: "yyyy-mm-dd",
          },
          render: () => {
            return this.warehouseBaseInfo.contractStartDate || "--";
          },
        },
        {
          label: this.$t("fbb.manageware.daiceendtime", {
            defaultValue: "合同结束时间",
          }),
          key: "contractEndDate",
          tag: "vDatepicker",
          required: false,
          props: {
            format: "yyyy-mm-dd",
          },
          render: () => {
            return this.warehouseBaseInfo.contractEndDate || "--";
          },
        },
        {
          label: this.$t("fbb.manageware.bussiness_email", {
            defaultValue: "仓库作业邮箱",
          }),
          key: "contactEmail",
          tag: "vInput",
          render: () => {
            return this.warehouseBaseInfo.contactEmail || "--";
          },
        },
        {
          label: this.$t("global.common.timeZone", { defaultValue: "时区" }),
          key: "timeZoneId",
          tag: "vSelect",
          options: this.getNewTimeZone(),
          required: false,
          render: () => {
            return this.setTimeZoneCode() || "--";
          },
          props: {
            filterable: true,
          },
          on: {
            "on-change": this.setTimeZoneCode,
          },
        },
        {
          label: '退货最晚确认时间天数',
          key: 'returnLastDay',
          tag: "InputNumber",
          props: {
            min: 0,
            style: 'width:100%'
          }
        },
        {
          label: this.$t("fbb.manageware.deliveryRemark", { defaultValue: "送仓注意事项", }),
          key: "deliveryRemark",
          tag: "vTextarea",
          required: false,
          render: () => {
            return this.warehouseBaseInfo.deliveryRemark || "--";
          },
        },
        {
          label: this.$t("global.common.notes", { defaultValue: "备注", }),
          key: "description",
          tag: "vTextarea",
          required: false,
          render: () => {
            return this.warehouseBaseInfo.description || "--";
          },
        },
      ];
      if (this.type === 'query') {
        baseArr.push({
          label: this.$t("fbb.manageware.attachesList", { defaultValue: "附件", }),
          key: "attachesList",
          tag: "div",
          required: false,
          render: () => {
            let attachesListDom;
            if (this.attachesList.length > 0) {
              attachesListDom = <div>
                {this.attachesList.map((item, index) =>
                  <div key={index}>
                    <a style="color:skyblue" href={item.fileurl} target="_blank">{item.filename}</a>
                  </div>
                )}
              </div>
            } else {
              attachesListDom = '--'
            }
            return attachesListDom
          },
        })
      } else {
        baseArr.push({
          label: "附件",
          key: "attachesList",
          tag: "div",
          required: false,
          children: (h) => {
            return (<div>
              {this.attachesList.map((item, index) =>
                <div key={index}>
                  <a style="color:skyblue" href={item.fileurl} target="_blank">{item.filename}</a>
                  <a style="vertical-align: middle;margin-left: 10px;">
                    <Icon type="ios-close" size="15" onClick={() => this.deleteAttaches(item.id)} />
                  </a>
                </div>
              )}
              <Button type="info" onClick={this.uploadAttachmentShow}>选择文件</Button>
            </div>)
          },
        })
      }
      return baseArr
    },
    //地址信息
    getAddress() {
      return [
        {
          label: this.$t("global.common.country", {
            defaultValue: "国家",
          }),
          key: "country",
          tag: "vSelect",
          options: this.getCountryList,
        },
        {
          label: this.$t("erp.b2c.state_province", {
            defaultValue: "州/省",
          }),
          key: "state",
          tag: this.warehouseAddress.country === "US" ? "vSelect" : "vInput",
          options: this.getStateList,
        },
        {
          label: this.$t("erp.b2c.city", { defaultValue: "城市" }),
          key: "city",
        },
        {
          label: this.$t("erp.b2c.zip_code", {
            defaultValue: "邮编",
          }),
          key: "postal",
          formItem: {
            rules: {
              required: true,
              validator: (rule, value, callback) => {
                if (!value || value.length < 5) {
                  callback(this.$t("fbb.warehouse.length_ge_5", {
                    defaultValue: "不得低于5位",
                  }))
                } else {
                  callback();
                }
              },
            },
          },
        },
        {
          label: this.$t("erp.b2border.addressone", {
            defaultValue: "详细地址1",
          }),
          key: "address",
        },
        {
          label: this.$t("erp.b2border.addresstwo", {
            defaultValue: "详细地址2",
          }),
          key: "address2",
          required: false,
          render: () => {
            return this.warehouseAddress.address2 || "--";
          },
        },
        {
          label: this.$t("erp.b2border.linkman", {
            defaultValue: "联系人",
          }),
          key: "linkman",
          required: false,
          render: () => {
            return this.warehouseAddress.linkman || "--";
          },
        },
        {
          label: this.$t("erp.b2c.phone", { defaultValue: "电话" }),
          key: "phone",
          required: false,
          render: () => {
            return this.warehouseAddress.phone || "--";
          },
        },
        {
          label: this.$t("erp.manageware.manager_email", {
            defaultValue: "仓库经理邮箱",
          }),
          key: "email",
          required: false,
          render: () => {
            return this.warehouseAddress.email || "--";
          },
        },
        {
          label: this.$t("global.common.mobile", {
            defaultValue: "移动电话",
          }),
          key: "mobilePhone",
          required: false,
          render: () => {
            return this.warehouseAddress.mobilePhone || "--";
          },
        },
      ];
    },
    getOtherInfo() {
      return [
        {
          label: this.$t("global.common.depotApiType", {
            defaultValue: "推送仓库系统",
          }),
          key: "depotApiType",
          tag: "vSelect",
          options: this.getWarehouseSys,
          required: false,
        },
        // {
        //     label: this.$t("global.common.onsite_warehouse_address", {
        //         defaultValue: "onsite仓所在仓库",
        //     }),
        //     key: "onsiteWarehouseId",
        //     tag: "vSelect",
        //     options: this.getBillcusWareList.filter((item) => {
        //         return (
        //             item.attach.warehouseType == 1 &&
        //             item.attach.active == 1
        //         );
        //     }),
        //     required: false,
        // },
        {
          label: this.$t("", { defaultValue: "仓库所属区域" }),
          key: "areaId",
          tag: "vSelect",
          required: false,
          options: this.areaList.filter(
            (item) => item.attach.code === this.warehouseAddress.country
          ),
        },
        {
          label: "关联服务仓/虚拟仓",
          key: "relWarehouseId",
          // 选择中转仓才展示
          show: this.isTransfer,
          tag: "vSelect",
          props: {
            filterable: true,
          },
          required: false,
          options: this.getBillcusWareList.filter((item) => {
            return item.attach.warehouseType == 1 && item.attach.active == 1;
          }),
        },
        {
          label: "日均收柜数量",
          key: "cartonQty",
          tag: "vInputNumber",
          props: {
            min: 0,
          },
          required: false,
        },
        {
          label: "业务模式",
          key: "businessType",
          tag: "vCheckBox",
          props: {
            strict: false,
          },
          render: (h) => {
            let text = this.formData.businessType
              .map((value) => {
                return this.getBusinessType.filter((item) => {
                  return item.trueValue == value;
                })[0].label;
              })
              .join(",");
            return text || "--";
          },
          options: this.getBusinessType,
          required: false,
        },
        {
          label: '是否前打单',
          key: 'isLabelBefore',
          tag: 'Select',
          options: [
            { label: '是', value: '1' },
            { label: '否', value: '0' },
          ],
          required: false,
          formItem: {
            tip: this.type != 'query' ? "<div class=color-error>该配置信息默认应用到新客户，已配置过的客户不做修改。</div>" : '',
          }
        },
        {
          label: "是否推送附件",
          key: 'isAttachHandling',
          tag: 'vRadio',
          options: [
            { trueValue: '1', label: this.$t('erp.global.yes', { defaultValue: '是' }) },
            { trueValue: '0', label: this.$t('erp.global.no', { defaultValue: '否' }) },
          ],
          required: false,
          formItem: {
            tip: this.type != 'query' ? "<div class=color-error>该配置信息默认应用到新客户，已配置过的客户不做修改。</div>" : '',
          }
        }
      ];
    },
    // 操作历史
    getLogcolumns() {
      return [
        {
          title: this.$t("global.log.operator", {
            defaultValue: "操作人",
          }),
          key: "opUserName",
        },
        {
          title: this.$t("global.log.action", {
            defaultValue: "操作类型",
          }),
          key: "opAction",
          // render:(h,{row})=>{
          //     return <div>{row.carrierServiceCode} ({row.carrierCode} {row.carrierServiceName})</div>
          // }
        },

        // {
        //   title: this.$t("fbb.accountmanage.param", {
        //     defaultValue: "更改字段",
        //   }),
        //   key: "changeField",
        // },
        // {
        //   title: this.$t("global.common.before_value", {
        //     defaultValue: "更改前值",
        //   }),
        //   key: "beforeChange",
        // },
        // {
        //   title: this.$t("global.common.after_value", {
        //     defaultValue: "更改后值",
        //   }),
        //   key: "afterChange",
        // },
        {
          title: this.$t('global.common.notes', { defaultValue: '备注' }),
          key: 'opData'
        },
        {
          title: this.$t("global.log.date", {
            defaultValue: "操作时间",
          }),
          key: "opAt",
        },
      ];
    },
    getBusinessType() {
      return [
        {
          label: "B2B",
          trueValue: 1,
        },
        {
          label: "B2C",
          trueValue: 2,
        },
      ];
    },
  },
  methods: {
    uploadAttachmentShow() {
      this.uploadAttachmentModal = true
    },
    handleAttach(res) {
      if (this.type === 'add') {
        this.dataList.push(res.data);
      } else {
        this.$emit('on-update')
      }
      this.showAttach = false;
    },
    handleWarehouseType(val) {
      if (val !== 0 && !val) return;
      // 中转仓
      if (val == 6) {
        this.isTransfer = true;
      }
      this.warehouseBaseInfo.warehouseType = val;
      this.selectText = this.getWarehouseTypes.filter((item) => {
        return item.value === val;
      })[0].text;
    },
    getNewTimeZone() {
      const newTimeZone = this.getTimeZone.map((item) => {
        return {
          value: item.value,
          label: item.label,
          code: item.attach.code,
        };
      });
      return newTimeZone;
    },
    setTimeZoneCode() {
      if (this.warehouseBaseInfo.timeZoneId) {
        const res = this.getNewTimeZone().filter((item) => {
          return item.value === this.warehouseBaseInfo.timeZoneId;
        });
        this.$set(this.warehouseBaseInfo, "timeZoneCode", res[0].code);
        return res[0].label;
      }
    },
    getArea() {
      HttpAreaList()
        .then((res) => {
          res.data.map((item) =>
            this.areaList.push({
              value: item.id,
              label: `${item.areaName}`,
              attach: {
                name: item.areaName,
                id: item.id,
                code: item.regionCode,
              },
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取计划单详情
    getDetail() {
      if (this.type === "add") return;
      this.loading = true;
      HttpManageWare({ id: this.id })
        .then((res) => {
          const data = res.data || {};
          this.loading = false;
          this.warehouseBaseInfo = {
            ...data.warehouseBaseInfo,
            hoseOrgId: this.warehouseBaseInfo.hoseOrgId,
            hoseOrgName: this.warehouseBaseInfo.hoseOrgName,
            returnLastDay: data.returnLastDay,
          };
          this.attachesList = res.data.attachesList
          this.zoneClosingTime = res.data.zoneClosingTime
          if (this.warehouseBaseInfo.receiveStartTime && this.warehouseBaseInfo.receiveEndTime) {
            this.warehouseBaseInfo.reserveTime = this.warehouseBaseInfo.receiveStartTime + '~' + this.warehouseBaseInfo.receiveEndTime
          }
          // this.warehouseType = data.warehouseBaseInfo.warehouseType;
          this.warehouseAddress = data.warehouseAddress;
          this.warehouseOrgChannels = data.warehouseOrgChannels;
          this.formData = {
            id: data.id,
            depotApiType: data.depotApiType,
            onsiteWarehouseId: data.onsiteWarehouseId,
            areaId: data.areaId,
            businessType: data.businessType,
            relWarehouseId: data.relWarehouseId,
            cartonQty: data.cartonQty,
            isLabelBefore: data.warehouseBaseInfo.isLabelBefore,
            isAttachHandling: data.warehouseBaseInfo.isAttachHandling || '1',

          };
          this.logList = data.carrierRuleLogs;
          this.warehouseTypeLabel = this.getWarehouseTypes.filter((item) => {
            return item.value == this.warehouseBaseInfo.warehouseType;
          })[0].label;
          // 中转仓类型
          if (res.data.warehouseBaseInfo.warehouseType == 6) {
            this.isTransfer = true;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$VMessage.error(
            this.$t(err.langCode, { defaultValue: err.message })
          );
        });
    },
    //更新单据数据
    async save() {
      let flag = true;
      await this.$refs.myForm.validate((valid) => {
        return (flag = valid);
      });
      if (!flag) return;
      await this.$refs.formbase.validate((valid) => {
        return (flag = valid);
      });
      if (!flag) return;
      await this.$refs.formaddress.validate((valid) => {
        return (flag = valid);
      });
      if (!flag) return this.$VMessage.error(flag);
      if (this.warehouseBaseInfo.capacity) {
        let capacity = Number(this.warehouseBaseInfo.capacity);
        if (isNaN(capacity) || capacity < 0) {
          return this.$VMessage.error(
            this.$t("fbb.warehouse.data_ge_0", {
              defaultValue: "请填写大于0的数字！",
            })
          );
        }
      }
      //   const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      const regEmail = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
      if (this.warehouseBaseInfo.contactEmail && !regEmail.test(this.warehouseBaseInfo.contactEmail)) {
        return this.$VMessage.error('请填写正确的邮箱！')
      }
      this.loading = true;
      this.warehouseBaseInfo.isLabelBefore = this.formData.isLabelBefore
      this.warehouseBaseInfo.isAttachHandling = this.formData.isAttachHandling
      this.formData.returnLastDay = this.warehouseBaseInfo.returnLastDay
      this.warehouseBaseInfo.receiveStartTime = this.warehouseBaseInfo.reserveTime.split('~')[0]
      this.warehouseBaseInfo.receiveEndTime = this.warehouseBaseInfo.reserveTime.split('~')[1]
      delete this.formData.isAttachHandling
      delete this.formData.isLabelBefore
      delete this.warehouseBaseInfo.returnLastDay
      delete this.formData.reserveTime
      HttpSaveManageWare({
        ...this.formData,
        warehouseBaseInfo: this.warehouseBaseInfo,
        warehouseAddress: this.warehouseAddress,
        warehouseOrgChannels: this.handlerOrgChannels(),
        attachesList: this.type === 'add' ? this.attachesList : []
      })
        .then(() => {
          this.$store.commit("dictionary/clearStore", "billcusWareList");
          this.cancel();
        })
        .catch((err) => {
          this.loading = false;
          const message =
            (err.message || "").indexOf("permission") > -1
              ? this.$t("erp.code.800100012", {
                defaultValue: "无操作权限",
              })
              : err.message;
          this.$VMessage.error(
            this.$t(err.langCode, { defaultValue: message })
          );
        });
    },
    //合并仓库组织
    handlerOrgChannels() {
      const result = {};
      const findOrgData = (id) =>
        this.getBillcusorgList.find((item) => item.value == id);
      const orgIds =
        (this.$refs.warehouseOrgIds && this.$refs.warehouseOrgIds.targetKeys) ||
        [];
      const channelIds =
        (this.$refs.channelIds && this.$refs.channelIds.getTargetData) || [];
      orgIds.forEach((orgId) => {
        result[orgId] = {
          orgId,
        };
      });
      // console.log(channelIds,'channelIdschannelIds')
      // console.log(orgIds,'orgIdsorgIds')
      channelIds.forEach((item) => {
        const orgData = findOrgData(item.orgId);
        item.orgCode = orgData.attach.code;
      });
      for (let key in result) {
        const orgData = findOrgData(key);
        if (orgData) {
          result[key].orgCode = orgData.attach.code;
        }
      }
      if (channelIds.length > 1) {
        return channelIds;
      } else {
        return Object.values(result);
      }
      // console.log(channelIds)
      // return Object.values(result) || channelIds;
    },
    cancel() {
      this.$router.push({
        name: "basicdataManageware",
      });
    },
    //删除页面附件元素
    deleteAttachesInArr(id) {
      if (this.attachesList.length > 0) {
        this.attachesList.forEach((item, index) => {
          if (item.id === id) {
            this.attachesList.splice(index, 1)
          }
        })
      }
    },
    //附件上传成功
    uploadAttachmentSuccess(res) {
      this.attachesList.push(res.data)
    },
    //附件modal关闭
    uploadAttachmentClose() {
      this.uploadAttachmentModal = false
    },
    //删除单个附件
    deleteAttaches(id) {
      HttpWarehouseListDeleteAttaches(
        {
          attachId: id,
          id: this.id,
          contextId: global.SYSID,
        },
      ).then(res => {
        this.deleteAttachesInArr(id)
      }).catch(err => {
        this.$VMessage.error(err.message);
      })
    }
  },
};
</script>
